import React, { useEffect, useState } from "react";
import api from "../api/axios";

export default function DoctorReviewForm({ sessionId, user, analysis }) {
  const [form, setForm] = useState({
    doctor_name: "",
    clinic_name: "",
    additional_tests: "",
    medicine_changes: "",
    final_note: "",
  });

  const [saving, setSaving] = useState(false);
  const [savedMessage, setSavedMessage] = useState("");

  useEffect(() => {
    setForm((prev) => ({
      ...prev,
      doctor_name: user?.name || "",
      final_note: analysis?.doctor_note || "",
    }));
  }, [user, analysis]);

  const updateField = (key, value) => {
    setForm((prev) => ({ ...prev, [key]: value }));
  };

  const saveReview = async () => {
    try {
      setSaving(true);
      setSavedMessage("");

      await api.post("/api/review/save", {
        session_id: sessionId,
        doctor_name: form.doctor_name,
        clinic_name: form.clinic_name,
        additional_tests: form.additional_tests,
        medicine_changes: form.medicine_changes,
        final_note: form.final_note,
      });

      setSavedMessage("Doctor review saved successfully.");
    } catch (e) {
      alert(e?.response?.data?.detail || "Could not save doctor review");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="card">
      <div className="section-head">
        <div>
          <h2>Doctor Review</h2>
          <p className="muted">
            Add final tests, medicine adjustments, and a formal note before opening the case sheet.
          </p>
        </div>
      </div>

      <div className="question-grid">
        <div className="field-block">
          <label>Doctor Name</label>
          <input
            value={form.doctor_name}
            onChange={(e) => updateField("doctor_name", e.target.value)}
            placeholder="Doctor name"
          />
        </div>

        <div className="field-block">
          <label>Clinic / Hospital</label>
          <input
            value={form.clinic_name}
            onChange={(e) => updateField("clinic_name", e.target.value)}
            placeholder="Clinic or hospital name"
          />
        </div>

        <div className="field-block full-span">
          <label>Additional Tests</label>
          <textarea
            value={form.additional_tests}
            onChange={(e) => updateField("additional_tests", e.target.value)}
            placeholder="Add tests the doctor wants to include beyond AI suggestions"
          />
        </div>

        <div className="field-block full-span">
          <label>Medicine Changes / Prescription</label>
          <textarea
            value={form.medicine_changes}
            onChange={(e) => updateField("medicine_changes", e.target.value)}
            placeholder="Doctor-prescribed medicines or changes in current medicines"
          />
        </div>

        <div className="field-block full-span">
          <label>Final Doctor Note</label>
          <textarea
            value={form.final_note}
            onChange={(e) => updateField("final_note", e.target.value)}
            placeholder="Final note to appear in the clinical case sheet"
          />
        </div>
      </div>

      <div className="review-actions">
        <button
          className="btn btn-primary"
          onClick={saveReview}
          disabled={saving}
          type="button"
        >
          {saving ? "Saving..." : "Save Doctor Review"}
        </button>

        {savedMessage ? <span className="saved-pill">{savedMessage}</span> : null}
      </div>
    </div>
  );
}